import { VStack } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { BorrowingBaseReportGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { BorrowingBaseSummaryCash } from './BorrowingBaseSummaryCash';
import { BorrowingBaseSummaryFacilitySummary } from './BorrowingBaseSummaryFacilitySummary';
import { BorrowingBaseSummaryFinalBorrowingBaseReport } from './BorrowingBaseSummaryFinalBorrowingBaseReport';
import { BorrowingBaseSummaryReceivables } from './BorrowingBaseSummaryReceivables';
import { BorrowingBaseSummarySections } from './utils';
import { LocalizationProvider } from 'packages/localization';

type BorrowingBaseSummaryWithComparisonValueProps = {
  sections: BorrowingBaseSummarySections[];
  borrowingBaseReports: {
    minuend: BorrowingBaseReportGQLType;
    reference: BorrowingBaseReportGQLType | undefined;
  };
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
};
export const BorrowingBaseSummaryWithValueAndReference = ({
  sections,
  borrowingBaseReports,
  creditAgreement,
}: BorrowingBaseSummaryWithComparisonValueProps) => {
  const includesSection = (section: BorrowingBaseSummarySections) =>
    _.includes(sections, section);

  const showComparisonAndDifferenceColumns = false;
  const showValueAndReferenceColumnsOnly = true;

  return (
    <LocalizationProvider scope="borrowingBaseSummary">
      <VStack mb="24px" spacing="32px" w="100%">
        {includesSection(BorrowingBaseSummarySections.facilitySummary) && (
          <BorrowingBaseSummaryFacilitySummary
            borrowingBaseReports={borrowingBaseReports}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
        {includesSection(BorrowingBaseSummarySections.receivables) && (
          <BorrowingBaseSummaryReceivables
            borrowingBaseReports={borrowingBaseReports}
            creditAgreement={creditAgreement}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
        {includesSection(BorrowingBaseSummarySections.cash) && (
          <BorrowingBaseSummaryCash
            borrowingBaseReports={borrowingBaseReports}
            creditAgreement={creditAgreement}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
        {includesSection(
          BorrowingBaseSummarySections.finalBorrowingBaseReport,
        ) && (
          <BorrowingBaseSummaryFinalBorrowingBaseReport
            borrowingBaseReports={borrowingBaseReports}
            showComparisonAndDifferenceColumns={
              showComparisonAndDifferenceColumns
            }
            showValueAndReferenceColumnsOnly={showValueAndReferenceColumnsOnly}
          />
        )}
      </VStack>
    </LocalizationProvider>
  );
};
